import { forEach } from '@mindkomm/utils';

/**
 * Check if the first letter on an element is the same
 * as the provided keyCode.
 *
 * @param el
 * @param letter
 * @returns {boolean}
 */
export function checkLetters(el, letter) {
  var firstLetter = el.textContent
    .trim()
    .substring(0, 1)
    .toLowerCase();

  if (firstLetter !== '' && firstLetter === letter) {
    el.focus();
    return true;
  }

  return false;
}

export function findStartLetterInCollection(collection, selector, keyCode) {
  var found = false;
  var letter = String.fromCharCode(keyCode).toLowerCase();

  forEach(
    collection,
    function(el) {
      forEach(
        el.querySelectorAll(selector),
        function(el) {
          if (checkLetters(el, letter)) {
            found = true;
            return false;
          }
        }.bind(this)
      );

      if (found) {
        return false;
      }
    }.bind(this)
  );

  return found;
}
